import {MissingTranslationHandler, MissingTranslationHandlerParams} from "@ngx-translate/core";

export class MissingTranslationService implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        return `The label '${params.key}' is missing '${params.translateService.currentLang}'`;
    }
}
